
import { Box } from '@primer/react';
import { useAuth } from '../hooks/useAuth';
import AppButton from '../components-ui/app-button';


const AppList = () => {
    const { user } = useAuth();
    const menus = user?.menus ?? [];
    return (
        <div style={{
            width: "100%",

        }}>
            {menus.map(menu => {
                return (
                    <div style={{ marginBottom: 4 }} key={menu.id}>
                        <AppButton key={menu.id}
                            module={menu}

                        />
                    </div>
                )
            })}

        </div>
    );
};

export default AppList;